import ContactFormFr from 'components/ContactUs/ContactFormFr'
import FooterFr from 'components/FooterFr'
import NavbarFr from 'components/NavbarFr'
import React from 'react'
import { useSelector } from 'react-redux';
import MobileNavbarFr from 'components/MobileNavbarFr';
import MobileFooterFr from 'components/MobileFooterFr';
import { useEffect } from "react";

function ContactUsFr() {
  const isMobile = useSelector(state=> state.windowSize.isMobile)
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <ContactFormFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <ContactFormFr />
      <FooterFr />
      </>
    )}
    </>
  )
}

export default ContactUsFr


